import SignUpJpg from './sign-up.jpg'
import SignUpWebp from './sign-up.webp'
import SignUp2xJpg from './sign-up@2x.jpg'
import SignUp2xWebp from './sign-up@2x.webp'
import SignUp3xJpg from './sign-up@3x.jpg'
import SignUp3xWebp from './sign-up@3x.webp'

import QRCodeCnSignupJpg from './qrcode-cn-signup.jpg'
import QRCodeCnSignupJpg2xJpg from './qrcode-cn-signup@2x.jpg'
import QRCodeCnSignupJpg3xJpg from './qrcode-cn-signup@3x.jpg'
import QRCodeCnSignupJpgWebp from './qrcode-cn-signup.webp'
import QRCodeCnSignupJpg2xWebp from './qrcode-cn-signup@2x.webp'
import QRCodeCnSignupJpg3xWebp from './qrcode-cn-signup@3x.webp'

import EmailConfirmationTopFoldJpg from './email-confirmation.jpg'
import EmailConfirmationTopFoldWebp from './email-confirmation.webp'
import EmailConfirmationTopFold2xJpg from './email-confirmation@2x.jpg'
import EmailConfirmationTopFold2xWebp from './email-confirmation@2x.webp'
import EmailConfirmationTopFold3xJpg from './email-confirmation@3x.jpg'
import EmailConfirmationTopFold3xWebp from './email-confirmation@3x.webp'

const SignUpImgs = {
  jpg: [SignUpJpg, SignUp2xJpg, SignUp3xJpg],
  webp: [SignUpWebp, SignUp2xWebp, SignUp3xWebp],
}

const QRCodeCnSignup = {
  jpg: [QRCodeCnSignupJpg, QRCodeCnSignupJpg2xJpg, QRCodeCnSignupJpg3xJpg],
  webp: [QRCodeCnSignupJpgWebp, QRCodeCnSignupJpg2xWebp, QRCodeCnSignupJpg3xWebp],
}

const EmailConfirmationTopFold = {
  jpg: [EmailConfirmationTopFoldJpg, EmailConfirmationTopFold2xJpg, EmailConfirmationTopFold3xJpg],
  webp: [
    EmailConfirmationTopFoldWebp,
    EmailConfirmationTopFold2xWebp,
    EmailConfirmationTopFold3xWebp,
  ],
}

export {default as CMSBackgroundTiles1} from './cms-background-tiles-1.png'
export {default as CMSBackgroundTiles2} from './cms-background-tiles-2.png'

export const imageList = {
  SignUpImgs,
  QRCodeCnSignup,
  EmailConfirmationTopFold,
}
